<template>
  <div class="searchPage">
    <Waiting></Waiting>
    <Navigation :showUserNav="true"></Navigation>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 SearchOptions m-t-4 p-r-3">
          <SearchBar orientation="vertical" :showTitle="true" v-on:search="searchLocal()"></SearchBar>
        </div>
        <div class="col-md-8">
          <div class="searchResults row m-t-2">
            <div class="displayOptions m-b-3" v-if="activities.length > 0">
              <button class="btn btn-primary" @click="setView('grid')"><i class="fa fa-th-large"></i></button>
              <button class="btn btn-primary" @click="setView('list')"><i class="fa fa-th-list"></i></button>
            </div>
            <div v-for="activity in activities" class="activityCardContainer" v-bind:class="{grid: (cardSize === 'small'), list: (cardSize === 'large')}">
              <router-link class="activityLink" :to="'/'+language+'/activity/'+activity.slug">
                <ActivityCard :activity="activity" class="sameHeight" :size="cardSize"></ActivityCard>
              </router-link>
            </div>
            <div v-if="!activities.length && !loading" class="noResults m-t-3">
              <h2 class="m-b-2">{{t('Sorry no activities were found for your search query.')}}</h2>
              <router-link class="btn btn-primary" :to="`/${language}`">{{t('go back')}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';
import Navigation from '../Navigation/Navigation';
import ActivityCard from '../Activity/ActivityCard';
import MatchHeight from 'jquery-match-height'; // eslint-disable-line
import Waiting from '../Waiting';
import SearchBar from '../Home/Search';

const $ = window.$;

export default {
  name: 'Search',
  components: {
    Navigation,
    ActivityCard,
    Waiting,
    SearchBar,
  },
  data() {
    return {
      cardSize: 'large',
    };
  },
  computed: {
    ...mapState({
      activities: state => state.search.activities,
      loading: state => state.search.loading,
      language: state => state.language,
    }),
  },
  methods: {
    ...mapActions({
      setDates: 'search/setDates',
      search: 'search/get',
    }),
    setView(type) {
      if (type === 'grid') {
        this.cardSize = 'small';
      } else if (type === 'list') {
        this.cardSize = 'large';
      }
      $('.sameHeight').matchHeight();
      setTimeout(() => {
        $('.sameHeight').matchHeight();
      }, 800);
    },
    searchLocal() {
      if (typeof this.$route.query.startDate !== 'undefined'
      || typeof this.$route.query.endDate !== 'undefined') {
        this.search(this.$route.query);
      } else {
        this.$router.push(`/${this.language}`);
      }
    },
  },
  watch: {
    activities() {
      setTimeout(() => {
        $('.sameHeight').matchHeight();
      }, 500);
    },
  },
  mounted() {
    this.searchLocal();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4";
.searchPage {
  min-height: 100vh ;
  padding-bottom: 100px;
}

.searchResults {
  font-size: 0;
}

.activityCardContainer {
  font-size: 1rem;
  display: inline-block;
  vertical-align: top;
  padding: 0 15px 30px 15px;
  &.list {
    width: 100%;
  }
  &.grid {
    width: calc(100% / 3);
  }
  transition: all 0.5s;
}
@media only screen and (max-width: 1350px) {
 .activityCardContainer.grid {
    width: calc(100% / 2);
  }
}
@media only screen and (max-width: map-get($grid-breakpoints, sm)) {
 .activityCardContainer.grid {
    width: calc(100% / 1);
  }
}
.sameHeight {
transition: height 0.5s;
}
.noResults {
  font-size: 16px;
  text-align: center;
  padding-top: 50px;
  .btn {
    margin-top: 50px;
  }
}

.displayOptions {
  .btn {
    min-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// Search.vue?7f3587f1